(function () {
  var PORTAL_SELECTOR = '.xb-ext-portal';
  var MODAL_SELECTOR = '.xb-wishlist-modal';
  var LOADER_CLASS = 'ld-wishlist-loader';
  var LIST_LOADING_CLASS = 'ld-wishlist-list-loading';
  var ATC_HIDDEN_CLASS = 'ld-wishlist-atc-hidden';
  var ATC_ALLOWED_CLASS = 'ld-wishlist-atc-allowed';
  var ROW_BLOCKED_CLASS = 'ld-wishlist-row-blocked';
  var ROW_READY_ATTR = 'data-ld-wishlist-row-ready';
  var protectionCache = new Map();
  var inFlightByHandle = new Map();
  var portalObserver = null;
  var modalObserver = null;
  var watchedModalEl = null;
  var evaluateTimer = null;
  var modalHeartbeatTimer = null;
  var blockedHandleSet = new Set();
  var DEBUG_ENABLED = false;
  var debugState = {
    initAt: Date.now(),
    cycles: 0,
    reasons: [],
    lastRows: 0,
    lastHandles: [],
    fetches: [],
    decisions: []
  };
  try {
    DEBUG_ENABLED = new URLSearchParams(window.location.search).get('wishlist-debug') === '1';
  } catch (e) {}
  window.__ldWishlistDebug = debugState;

  function debugLog() {
    if (!DEBUG_ENABLED) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[LD Wishlist]');
    console.log.apply(console, args);
  }

  function recordDebug(listKey, payload) {
    if (!debugState[listKey] || !Array.isArray(debugState[listKey])) return;
    debugState[listKey].push(payload);
    if (debugState[listKey].length > 200) {
      debugState[listKey].splice(0, debugState[listKey].length - 200);
    }
  }

  function scheduleEvaluate(reason) {
    debugLog('schedule evaluate', reason || 'scheduled');
    if (evaluateTimer) return;
    evaluateTimer = window.setTimeout(function () {
      evaluateTimer = null;
      try {
        debugLog('run evaluate', reason || 'scheduled');
        evaluateOpenModal(reason || 'scheduled');
      } catch (err) {
        debugLog('evaluate error', String(err && err.message ? err.message : err));
      }
    }, 50);
  }

  function getOpenModal() {
    var modals = document.querySelectorAll(PORTAL_SELECTOR + ' ' + MODAL_SELECTOR);
    if (!modals.length) return null;

    for (var i = 0; i < modals.length; i += 1) {
      var modal = modals[i];
      if (modal.querySelector('a[href*="/products/"]')) return modal;
    }
    return modals[modals.length - 1];
  }

  function ensureLoader(modal) {
    if (!modal) return;
    if (modal.querySelector('.' + LOADER_CLASS)) return;
    if (window.getComputedStyle(modal).position === 'static') {
      modal.style.position = 'relative';
    }
    var loader = document.createElement('div');
    loader.className = LOADER_CLASS;
    loader.setAttribute('aria-hidden', 'true');
    loader.innerHTML = '<span class="ld-wishlist-loader__spinner"></span><span class="ld-wishlist-loader__text">Checking wishlist items...</span>';
    modal.appendChild(loader);
  }

  function setLoadingState(modal, isLoading) {
    if (!modal) return;
    modal.classList.toggle(LIST_LOADING_CLASS, !!isLoading);
    var loader = modal.querySelector('.' + LOADER_CLASS);
    if (loader) loader.classList.toggle('is-active', !!isLoading);
  }

  function parseHandleFromUrl(href) {
    if (!href) return '';
    var match = href.match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? decodeURIComponent(match[1]).trim().toLowerCase() : '';
  }

  function findRowElement(anchor, modal) {
    var cursor = anchor;
    while (cursor && cursor !== modal) {
      if (findAtcTargets(cursor).length > 0) return cursor;
      cursor = cursor.parentElement;
    }
    return anchor.parentElement || anchor;
  }

  function isAddToCartNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.classList && node.classList.contains('xb-list-style__add-to-cart')) return true;
    var text = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    var ariaLabel = ((node.getAttribute && node.getAttribute('aria-label')) || '').toLowerCase();
    var nameAttr = ((node.getAttribute && node.getAttribute('name')) || '').toLowerCase();
    var valueAttr = ((node.getAttribute && node.getAttribute('value')) || '').toLowerCase();
    if (!text) return false;
    if (text.indexOf('add to cart') !== -1) return true;
    if (ariaLabel.indexOf('add to cart') !== -1) return true;
    if (nameAttr.indexOf('add') !== -1 && nameAttr.indexOf('cart') !== -1) return true;
    if (valueAttr.indexOf('add to cart') !== -1) return true;
    if (text === 'add') return true;
    return false;
  }

  function findAtcTargets(scope) {
    if (!scope || scope.nodeType !== 1) return [];
    var xbTargets = scope.querySelectorAll('.xb-list-style__add-to-cart');
    if (xbTargets && xbTargets.length) return Array.prototype.slice.call(xbTargets);
    if (scope.matches && scope.matches('.xb-list-style__add-to-cart')) return [scope];
    var candidates = scope.querySelectorAll('button, a, [role="button"], input[type="submit"], input[type="button"]');
    var hits = [];
    for (var i = 0; i < candidates.length; i += 1) {
      if (isAddToCartNode(candidates[i])) hits.push(candidates[i]);
    }
    return hits;
  }

  function setAtcVisibility(row, shouldShow) {
    var targets = findAtcTargets(row);
    for (var i = 0; i < targets.length; i += 1) {
      targets[i].classList.toggle(ATC_HIDDEN_CLASS, !shouldShow);
      targets[i].classList.toggle(ATC_ALLOWED_CLASS, !!shouldShow);
      if (shouldShow) {
        targets[i].style.setProperty('display', '', 'important');
        targets[i].style.setProperty('visibility', '', 'important');
      } else {
        targets[i].style.setProperty('display', 'none', 'important');
        targets[i].style.setProperty('visibility', 'hidden', 'important');
      }
    }
    row.classList.toggle(ROW_BLOCKED_CLASS, !shouldShow);
    row.setAttribute(ROW_READY_ATTR, 'true');
  }

  function hideAtcByDefault(modal) {
    var rows = collectRows(modal);
    for (var i = 0; i < rows.length; i += 1) {
      var row = rows[i].row;
      row.removeAttribute(ROW_READY_ATTR);
      row.classList.remove(ROW_BLOCKED_CLASS);
      setAtcVisibility(row, false);
    }
    return rows;
  }

  function getCookieValue(cookieKey) {
    if (!cookieKey) return '';
    var name = cookieKey + '=';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i += 1) {
      var c = parts[i].trim();
      if (c.indexOf(name) === 0) return c.substring(name.length);
    }
    return '';
  }

  function hasUnlockCookie(cookieKey) {
    var value = getCookieValue(cookieKey);
    return value === 'disabled';
  }

  function shouldAllowAtc(payload) {
    if (!payload || payload.error) return true;
    if (!payload.isPasswordProtected) return true;
    if (payload.isComing || payload.phase === 'coming') return false;
    if (payload.isPublic || payload.phase === 'public') return true;
    if (payload.isVip || payload.phase === 'vip') {
      // Customer-tag bypass disabled. A collection handle on the customer no longer unlocks.
      // if (payload.customerUnlocked) return true;
      return hasUnlockCookie(payload.vipCookieKey);
    }
    return true;
  }

  function fetchProtection(handle, options) {
    var opts = options || {};
    var bypassCache = !!opts.bypassCache;
    if (!handle) return Promise.resolve(null);
    if (!bypassCache && protectionCache.has(handle)) {
      debugLog('cache hit', handle);
      recordDebug('fetches', { handle: handle, cached: true, at: Date.now() });
      return Promise.resolve(protectionCache.get(handle));
    }
    if (inFlightByHandle.has(handle)) return inFlightByHandle.get(handle);

    var url = '/products/' + encodeURIComponent(handle) + '?view=ld-protection-json';
    debugLog('fetch start', handle, url);
    recordDebug('fetches', { handle: handle, cached: false, at: Date.now(), url: url });
    var requestPromise;
    if (typeof window.fetch === 'function') {
      requestPromise = window.fetch(url, { credentials: 'same-origin' });
    } else {
      requestPromise = new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState !== 4) return;
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve({
              ok: true,
              json: function () {
                return Promise.resolve(JSON.parse(xhr.responseText || '{}'));
              }
            });
          } else {
            reject(new Error('XHR protection lookup failed'));
          }
        };
        xhr.send();
      });
    }
    var promise = requestPromise
      .then(function (res) {
        if (!res.ok) throw new Error('Protection lookup failed');
        return res.json();
      })
      .then(function (json) {
        protectionCache.set(handle, json);
        debugLog('fetch done', handle, json && json.phase, json && json.isPasswordProtected);
        return json;
      })
      .catch(function () {
        debugLog('fetch failed', handle);
        var fallback = { handle: handle, error: true };
        if (protectionCache.has(handle) && protectionCache.get(handle).isPasswordProtected) {
          return protectionCache.get(handle);
        }
        protectionCache.set(handle, fallback);
        return fallback;
      })
      .finally(function () {
        inFlightByHandle.delete(handle);
      });

    inFlightByHandle.set(handle, promise);
    return promise;
  }

  function collectRows(modal) {
    var rows = [];
    if (!modal) return rows;
    var tableRows = modal.querySelectorAll('.xb-list-style__tbody tr');
    if (tableRows.length) {
      for (var t = 0; t < tableRows.length; t += 1) {
        var tr = tableRows[t];
        var titleLink = tr.querySelector('.xb-list-style__product-title a[href*="/products/"], a[href*="/products/"]');
        if (!titleLink) continue;
        var trHandle = parseHandleFromUrl(titleLink.getAttribute('href'));
        if (!trHandle) continue;
        rows.push({ row: tr, handle: trHandle });
      }
      return rows;
    }
    var anchors = modal.querySelectorAll('a[href*="/products/"]');
    var seen = new Set();
    for (var i = 0; i < anchors.length; i += 1) {
      var handle = parseHandleFromUrl(anchors[i].getAttribute('href'));
      if (!handle) continue;
      var row = findRowElement(anchors[i], modal);
      if (!row) continue;
      if (seen.has(row)) continue;
      seen.add(row);
      rows.push({
        row: row,
        handle: handle
      });
    }
    return rows;
  }

  function evaluateOpenModal(reason) {
    var modal = getOpenModal();
    if (!modal) {
      debugLog('evaluate skipped (no modal)', reason);
      return;
    }

    ensureLoader(modal);
    setLoadingState(modal, true);

    var rows = hideAtcByDefault(modal);
    if (!rows.length) {
      debugLog('evaluate no rows', reason);
      setLoadingState(modal, false);
      return;
    }
    debugState.cycles += 1;
    debugState.lastRows = rows.length;
    debugState.reasons.push({ reason: reason || 'unknown', at: Date.now() });
    if (debugState.reasons.length > 50) debugState.reasons.shift();
    debugLog('evaluate start', reason, 'rows', rows.length);

    var handles = [];
    var seenHandles = new Set();
    for (var i = 0; i < rows.length; i += 1) {
      if (!seenHandles.has(rows[i].handle)) {
        seenHandles.add(rows[i].handle);
        handles.push(rows[i].handle);
      }
    }
    debugState.lastHandles = handles.slice(0);
    debugLog('handles', handles.join(', '));

    Promise.all(handles.map(function (h) {
      try {
        return fetchProtection(h, { bypassCache: false });
      } catch (e) {
        return Promise.resolve({ handle: h, error: true });
      }
    }))
      .then(function () {
        blockedHandleSet.clear();
        for (var j = 0; j < rows.length; j += 1) {
          var item = rows[j];
          var payload = protectionCache.get(item.handle) || null;
          var allow = shouldAllowAtc(payload);
          setAtcVisibility(item.row, allow);
          recordDebug('decisions', {
            at: Date.now(),
            handle: item.handle,
            allow: allow,
            protected: !!(payload && payload.isPasswordProtected),
            phase: payload && payload.phase ? payload.phase : ''
          });
          debugLog('decision', item.handle, allow ? 'allow' : 'deny', payload && payload.phase);
          if (!allow) blockedHandleSet.add(item.handle);
        }
      })
      .finally(function () {
        setLoadingState(modal, false);
      });
  }

  function applyBlockedVisibilityFromCache(modal) {
    if (!modal) return;
    var rows = collectRows(modal);
    for (var i = 0; i < rows.length; i += 1) {
      var item = rows[i];
      var payload = protectionCache.get(item.handle) || null;
      var allow = shouldAllowAtc(payload);
      if (!allow) {
        setAtcVisibility(item.row, false);
        blockedHandleSet.add(item.handle);
      }
    }
  }

  function watchModal(modal) {
    if (!modal) return;
    if (watchedModalEl === modal && modalObserver) {
      return;
    }
    watchedModalEl = modal;
    if (modalObserver) modalObserver.disconnect();
    modalObserver = new MutationObserver(function () {
      applyBlockedVisibilityFromCache(modal);
      scheduleEvaluate('modal-mutation');
    });
    modalObserver.observe(modal, { childList: true, subtree: true });
    scheduleEvaluate('watch-modal-init');
  }

  function watchPortalLifecycle() {
    if (portalObserver) portalObserver.disconnect();
    portalObserver = new MutationObserver(function () {
      var modal = getOpenModal();
      if (modal && modal !== watchedModalEl) watchModal(modal);
    });
    portalObserver.observe(document.body, { childList: true, subtree: true });
    var modal = getOpenModal();
    if (modal && modal !== watchedModalEl) watchModal(modal);
  }

  function startModalHeartbeat() {
    if (modalHeartbeatTimer) window.clearInterval(modalHeartbeatTimer);
    modalHeartbeatTimer = window.setInterval(function () {
      var modal = getOpenModal();
      if (!modal) return;
      var hasRows = collectRows(modal).length > 0;
      if (hasRows) {
        scheduleEvaluate('heartbeat');
      }
    }, 600);
  }

  function runDeterministicOpenCycle() {
    try {
      evaluateOpenModal('open-cycle-immediate');
    } catch (err) {
      debugLog('open-cycle immediate error', String(err && err.message ? err.message : err));
    }
    var delays = [0, 80, 220, 520];
    for (var i = 0; i < delays.length; i += 1) {
      (function (delay) {
        window.setTimeout(function () {
          scheduleEvaluate('open-cycle-' + delay);
        }, delay);
      })(delays[i]);
    }
  }

  function findClosestRowWithHandle(node, modal) {
    var cursor = node;
    while (cursor && cursor !== modal) {
      if (cursor.nodeType === 1) {
        var link = cursor.querySelector('a[href*="/products/"]');
        if (link) {
          var handle = parseHandleFromUrl(link.getAttribute('href'));
          if (handle) return { row: cursor, handle: handle };
        }
      }
      cursor = cursor.parentElement;
    }
    return null;
  }

  function onModalClickCapture(event) {
    var modal = getOpenModal();
    if (!modal) return;
    var target = event.target && event.target.closest ? event.target.closest('button, a, [role="button"], input[type="submit"], input[type="button"]') : null;
    if (!isAddToCartNode(target)) return;
    var rowInfo = findClosestRowWithHandle(target, modal);
    if (!rowInfo) return;
    var payload = protectionCache.get(rowInfo.handle) || null;
    var allow = shouldAllowAtc(payload);
    if (!allow || blockedHandleSet.has(rowInfo.handle)) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchPortalLifecycle);
  } else {
    watchPortalLifecycle();
  }
  debugLog('script initialized');
  startModalHeartbeat();
  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest('.xb-wishlist__header, xb-wishlist-header, .xb-wishlist-header, .xb-wishlist-header__icon') : null;
    if (!trigger) return;
    debugLog('wishlist trigger click');
    runDeterministicOpenCycle();
  }, true);
  document.addEventListener('click', onModalClickCapture, true);
})();
